<!-- El fondo NO cierra. Este formato tiene veinte campos y una matriz
     de ocho criterios: un clic de mas al lado del modal se llevaba por
     delante todo lo escrito. Se sale por Cancelar o por la equis, que
     son actos deliberados. -->
<div class="dar">
  <!-- role/aria-modal/aria-labelledby: sin esto un lector de pantalla lee
       el formato como si fuera mas contenido de la pagina de atras, sin
       decir que se abrio un dialogo ni como se llama. -->
  <div class="dar__caja" role="dialog" aria-modal="true" aria-labelledby="darTitulo">

    <!-- ==================== Encabezado ==================== -->
    <header class="dar__cab">
      <span class="dar__ico"><span class="material-icons">description</span></span>
      <div class="dar__titulo">
        <h3 id="darTitulo">Archivo DAR</h3>
        <p>
          FOR-012 Reporte DAR · V 1.2 — lo mismo que trae el Excel, campo por campo.
          <ng-container *ngIf="!soloLectura">Todos los campos son obligatorios.</ng-container>
        </p>
      </div>
      <button type="button" class="dar-ico" (click)="intentaCerrar()"
              aria-label="Cerrar el Archivo DAR">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="dar__cuerpo">

      <!-- ---------- Proyecto y situación ---------- -->
      <section class="dar-sec">
        <h4>Proyecto y situación</h4>
        <div class="dar-campo">
          <label for="darArea" class="dar-lbl--req">Proyecto / Área</label>
          <input id="darArea" type="text" maxlength="200" [(ngModel)]="proyectoArea"
                 name="proyectoArea" [disabled]="soloLectura"
                 placeholder="Ej. Área de Desarrollo">
        </div>
        <div class="dar-campo">
          <label for="darSit" class="dar-lbl--req">Situación actual</label>
          <textarea id="darSit" rows="4" maxlength="2000"
                    [(ngModel)]="situacionActual" name="situacionActual"
                    [disabled]="soloLectura"
                    placeholder="Qué problema hay hoy, con qué carga de trabajo y con qué recursos."></textarea>
        </div>
      </section>

      <!-- ---------- Involucrados ---------- -->
      <section class="dar-sec">
        <div class="dar-sec__cab">
          <h4>Involucrados</h4>
          <!-- Con tope de renglones (29/09/2026): cada casilla ya tenía su
               largo, pero se podían agregar renglones sin fin. -->
          <button type="button" class="dar-mini" (click)="agregaInvolucrado()"
                  *ngIf="!soloLectura && involucrados.length < MAX_INVOLUCRADOS">
            <span class="material-icons">add</span> Agregar
          </button>
          <span class="dar-max" *ngIf="!soloLectura && involucrados.length >= MAX_INVOLUCRADOS">
            Máximo {{ MAX_INVOLUCRADOS }} involucrados
          </span>
        </div>
        <table class="dar-tabla">
          <thead>
            <tr>
              <th class="dar-lbl--req">Nombre</th>
              <th class="dar-lbl--req">Área / Proyecto / Servicio</th>
              <!-- La columna de las equis lleva titulo: sin el, ocho
                   botones rojos en fila no dicen que hacen. -->
              <th class="dar-tabla__x" *ngIf="!soloLectura">Quitar involucrado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let inv of involucrados; let i = index; trackBy: trackIndice">
              <td><input aria-label="Nombre" type="text" maxlength="120" [(ngModel)]="inv.nombre"
                         [name]="'invNom' + i" [disabled]="soloLectura"></td>
              <td><input aria-label="Área / Proyecto / Servicio" type="text" maxlength="120" [(ngModel)]="inv.area"
                         [name]="'invArea' + i" [disabled]="soloLectura"></td>
              <td class="dar-tabla__x" *ngIf="!soloLectura">
                <button type="button" class="dar-ico dar-ico--no"
                        (click)="quitaInvolucrado(i)" matTooltip="Quitar este involucrado"
                        [attr.aria-label]="'Quitar al involucrado ' + (i + 1)">
                  <span class="material-icons" aria-hidden="true">close</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- ---------- Alternativas y su evaluación ---------- -->
      <section class="dar-sec">
        <h4>Alternativas: selección y evaluación</h4>
        <div class="dar-campo">
          <!-- Tenía solo el título de la sección: se le pone su etiqueta
               con su marca de obligatorio (29/09/2026). -->
          <label for="darAltTexto" class="dar-lbl--req">Qué alternativas se comparan y por qué</label>
          <textarea id="darAltTexto" rows="4" maxlength="2000"
                    [(ngModel)]="alternativasTexto" name="alternativasTexto"
                    [disabled]="soloLectura"
                    placeholder="Se evalúan tres alternativas: OpenAI Codex, Claude Code y GitHub Copilot. Son las tres opciones del mercado con plan empresarial, respaldo institucional (OpenAI, Anthropic y Microsoft/GitHub) y soporte nativo en el entorno que ya usa el área. Las tres se evalúan para el trabajo completo del área — desarrollo de proyectos, seguridad, mantenimiento y soporte — no para una tarea en particular."></textarea>
        </div>

        <!-- La escala del formato, antes de las alternativas: se lee ANTES
             de calificar, que es cuando hace falta. Estuvo abajo, junto al
             botón de agregar criterio, y ahí nadie la veía hasta después
             de haber puesto los números. Cada valor va en su círculo de
             color, del rojo del 1 al verde del 5: el mismo verde con el
             que la matriz marca a la alternativa que va ganando. -->
        <div class="dar-escala" role="group" aria-labelledby="darEscalaTit">
          <div class="dar-escala__cab">
            <span class="dar-escala__tit" id="darEscalaTit">Calificación</span>
            <span class="dar-escala__nota">Con esta escala se califica cada alternativa en la matriz.</span>
          </div>
          <ul class="dar-escala__lista">
            <li class="dar-escala__it" *ngFor="let e of ESCALA" [attr.data-v]="e.valor">
              <span class="dar-escala__num" aria-hidden="true">{{ e.valor }}</span>
              <b>{{ e.nombre }}</b>
              <span class="dar-visual-oculto">= {{ e.valor }}</span>
            </li>
          </ul>
        </div>

        <!-- Tres al abrir, como el formato, pero ni tres fijas ni tres
             obligatorias: comparar dos herramientas es una comparación
             legítima y comparar cinco también. Quitar una se lleva SU
             columna de la matriz, no la última. -->
        <div class="dar-alts">
          <div class="dar-campo" *ngFor="let i of cols">
            <div class="dar-alts__cab">
              <label class="dar-lbl--req" [for]="'darAltNom' + i">Alternativa {{ i + 1 }}</label>
              <button type="button" class="dar-ico dar-ico--no dar-alts__x"
                      *ngIf="!soloLectura && alternativas.length > MIN_ALTS"
                      (click)="quitaAlternativa(i)"
                      matTooltip="Quitar esta alternativa"
                      [attr.aria-label]="'Quitar la alternativa ' + (i + 1)">
                <span class="material-icons" aria-hidden="true">close</span>
              </button>
            </div>
            <input type="text" [id]="'darAltNom' + i" maxlength="120" [(ngModel)]="alternativas[i]"
                   [name]="'alt' + i" [disabled]="soloLectura"
                   placeholder="Nombre de la herramienta">
          </div>

          <div class="dar-campo dar-alts__mas" *ngIf="!soloLectura">
            <button type="button" class="dar-mini" (click)="agregaAlternativa()"
                    *ngIf="alternativas.length < MAX_ALTS">
              <span class="material-icons">add</span> Agregar alternativa
            </button>
            <span class="dar-max" *ngIf="alternativas.length >= MAX_ALTS">
              Máximo {{ MAX_ALTS }} alternativas
            </span>
          </div>
        </div>

        <!-- La matriz. El puntaje y los totales se calculan: no se capturan. -->
        <div class="dar-caja">
          <table class="dar-tabla dar-tabla--matriz">
            <!-- Tres renglones de encabezado, como el FOR-012: el grupo
                 "Alternativas identificadas", el nombre de cada una, y
                 debajo sus dos columnas. -->
            <thead>
              <tr>
                <th rowspan="3" class="dar-tabla__criterio dar-lbl--req">Criterio / Parámetro</th>
                <th rowspan="3" class="dar-tabla__peso dar-lbl--req">Peso</th>
                <th [attr.colspan]="cols.length * 2" class="dar-tabla__grupo">
                  Alternativas identificadas
                </th>
                <th rowspan="3" class="dar-tabla__x" *ngIf="!soloLectura">
                  Quitar criterio
                </th>
              </tr>
              <tr>
                <th colspan="2" scope="col" class="dar-tabla__alt" *ngFor="let i of cols"
                    [class.es-mejor]="mejor === i">
                  {{ alternativas[i] || ("Alternativa " + (i + 1)) }}
                </th>
              </tr>
              <tr>
                <ng-container *ngFor="let i of cols">
                  <th class="dar-tabla__cal dar-lbl--req">Calificación</th>
                  <th class="dar-tabla__pts">Puntaje</th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of criterios; let f = index; trackBy: trackIndice">
                <td><input aria-label="Criterio / Parámetro" type="text" maxlength="120" [(ngModel)]="c.criterio"
                           [name]="'crit' + f" [disabled]="soloLectura"></td>
                <td class="dar-tabla__peso">
                  <!-- Del 1 al 5 y entero (29/09/2026): una lista, porque el
                       número libre dejaba teclear 50 o 2.5. -->
                  <select [(ngModel)]="c.peso" [name]="'peso' + f" [disabled]="soloLectura"
                          [attr.aria-label]="'Peso del criterio ' + (f + 1)">
                    <option *ngFor="let p of PESOS" [ngValue]="p">{{ p }}</option>
                  </select>
                </td>
                <ng-container *ngFor="let i of cols">
                  <td class="dar-tabla__cal">
                    <select aria-label="Calificación" [(ngModel)]="c.calif[i]" [name]="'cal' + f + '_' + i"
                            [disabled]="soloLectura">
                      <option [ngValue]="0">—</option>
                      <option *ngFor="let e of ESCALA" [ngValue]="e.valor">{{ e.valor }}</option>
                    </select>
                  </td>
                  <td class="dar-tabla__pts" [class.es-mejor]="mejor === i">
                    {{ puntaje(c, i) || "" }}
                  </td>
                </ng-container>
                <td class="dar-tabla__x" *ngIf="!soloLectura">
                  <button type="button" class="dar-ico dar-ico--no"
                          (click)="quitaCriterio(f)" matTooltip="Quitar este criterio"
                          [attr.aria-label]="'Quitar el criterio ' + (f + 1)">
                    <span class="material-icons" aria-hidden="true">close</span>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2" class="dar-tabla__totales"><b>Totales por alternativa</b></td>
                <ng-container *ngFor="let i of cols">
                  <td class="dar-tabla__cal"></td>
                  <td class="dar-tabla__pts" [class.es-mejor]="mejor === i">
                    <b>{{ total(i) || "" }}</b>
                  </td>
                </ng-container>
                <td *ngIf="!soloLectura"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="dar-sec__pie" *ngIf="!soloLectura">
          <button type="button" class="dar-mini" (click)="agregaCriterio()"
                  *ngIf="criterios.length < MAX_CRITERIOS">
            <span class="material-icons">add</span> Agregar criterio
          </button>
          <span class="dar-max" *ngIf="criterios.length >= MAX_CRITERIOS">
            Máximo {{ MAX_CRITERIOS }} criterios
          </span>
        </div>
      </section>

      <!-- ---------- Solución y riesgos ---------- -->
      <section class="dar-sec">
        <h4 class="dar-lbl--req">Solución final</h4>
        <div class="dar-campo">
          <textarea aria-label="Solución final" rows="4" maxlength="2000"
                    [(ngModel)]="solucionFinal" name="solucionFinal"
                    [disabled]="soloLectura"
                    placeholder="Qué se decide, con qué alcance y bajo qué condiciones."></textarea>
        </div>
      </section>

      <section class="dar-sec">
        <h4 class="dar-lbl--req">Riesgos</h4>
        <div class="dar-campo">
          <textarea aria-label="Riesgos" rows="4" maxlength="2000" [(ngModel)]="riesgos" name="riesgos"
                    [disabled]="soloLectura"
                    placeholder="Qué puede salir mal con esta IA y qué se hace al respecto."></textarea>
        </div>
      </section>

      <!-- ---------- Implementación ---------- -->
      <!-- Los cinco en una tabla y en el orden del Excel: son las cinco
           casillas de un mismo renglón del formato, no cinco campos
           sueltos. El encabezado hace de etiqueta, así que cada campo
           lleva su aria-label: sin eso, un lector de pantalla sólo
           diría "cuadro de texto". -->
      <section class="dar-sec">
        <h4>Implementación</h4>
        <div class="dar-caja">
          <table class="dar-tabla dar-tabla--impl">
            <thead>
              <tr>
                <th class="dar-lbl--req">Tiempo de implementación</th>
                <th class="dar-lbl--req">Costos de implementación</th>
                <th class="dar-lbl--req">Recurso humano y material</th>
                <th class="dar-lbl--req">Fecha implementación</th>
                <th class="dar-lbl--req">Responsable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <!-- El tiempo no es "1 día": es el plazo y debajo el plan, con
                     sus actividades numeradas. Por eso es área de texto y no
                     una línea, y el ejemplo va en el TS —con saltos de línea
                     de verdad— en vez de dentro del atributo. -->
                <td class="dar-tabla__tiempo">
                  <textarea id="darTiempo" rows="5" maxlength="2000"
                            [(ngModel)]="tiempoImplementacion" name="tiempoImplementacion"
                            [disabled]="soloLectura" [placeholder]="EJ_TIEMPO"
                            aria-label="Tiempo de implementación"></textarea>
                </td>
                <td>
                  <input id="darCostos" type="text" maxlength="150"
                         [(ngModel)]="costosImplementacion" name="costosImplementacion"
                         [disabled]="soloLectura" placeholder="Ej. Sin costo adicional"
                         aria-label="Costos de implementación">
                </td>
                <td class="dar-tabla__recurso">
                  <textarea id="darRecurso" rows="2" maxlength="2000"
                            [(ngModel)]="recursoHumanoMaterial" name="recursoHumanoMaterial"
                            [disabled]="soloLectura"
                            placeholder="Qué personal y qué recursos hacen falta."
                            aria-label="Recurso humano y material"></textarea>
                </td>
                <td>
                  <input id="darFecha" type="date" [(ngModel)]="fechaImplementacion"
                         name="fechaImplementacion" [disabled]="soloLectura"
                         aria-label="Fecha de implementación">
                </td>
                <td>
                  <input id="darResp" type="text" maxlength="150"
                         [(ngModel)]="responsableImplementacion"
                         name="responsableImplementacion" [disabled]="soloLectura"
                         placeholder="Quién lo implementa"
                         aria-label="Responsable de la implementación">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <!-- ---------- Historial de cambios (hoja HCC) ---------- -->
      <section class="dar-sec">
        <div class="dar-sec__cab">
          <h4>Control de cambios</h4>
          <span class="dar-auto">
            <span class="material-icons">auto_awesome</span>
            Se llena solo: la versión, quién lo elaboró y la fecha las pone el
            sistema
          </span>
        </div>
        <div class="dar-caja">
          <table class="dar-tabla dar-tabla--hcc">
            <thead>
              <tr>
                <th class="dar-tabla__ver">Versión</th>
                <th>Descripción</th>
                <th>Elaboró</th>
                <th class="dar-tabla__fec">Fecha</th>
                <th class="dar-tabla__aut dar-lbl--req">Autorizó</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let h of historial; let i = index; trackBy: trackIndice">
                <!-- Los cuatro primeros son datos del sistema: se leen, no
                     se teclean. Escribirlos a mano en un formato
                     controlado es justo donde se cuelan los errores. -->
                <td class="dar-tabla__ver"><b>{{ h.version }}</b></td>
                <td>{{ h.descripcion }}</td>
                <td>{{ h.elaboro || "—" }}</td>
                <td class="dar-tabla__fec">{{ fechaLegible(h.fecha) }}</td>
                <td class="dar-tabla__aut">
                  <input aria-label="Autorizó" type="text" maxlength="120" [(ngModel)]="h.autorizo"
                         [name]="'hAut' + i" [disabled]="soloLectura"
                         placeholder="Quién lo autoriza">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <!-- ==================== Pie ==================== -->
    <footer class="dar__pie">
      <!-- Todo el formato es obligatorio, asi que el boton se apaga y a
           su lado se dice QUE falta. Un boton apagado sin explicacion en
           un formulario de este largo es una pantalla rota. -->
      <span class="dar__nota" *ngIf="soloLectura">
        Evaluación cerrada: el DAR se consulta, no se modifica.
      </span>
      <span class="dar__nota dar__nota--falta" *ngIf="!soloLectura && falta">
        <span class="material-icons">info_outline</span>{{ falta }}
      </span>
      <span class="dar__nota dar__nota--listo" *ngIf="!soloLectura && !falta">
        <span class="material-icons">check_circle</span>El DAR está completo
      </span>

      <button type="button" class="dar-btn" (click)="intentaCerrar()">
        {{ soloLectura ? "Cerrar" : "Cancelar" }}
      </button>
      <button type="button" class="dar-btn dar-btn--primario" *ngIf="!soloLectura"
              [disabled]="!!falta" (click)="aceptar()">
        <span class="material-icons">check</span> Guardar DAR
      </button>
    </footer>
  </div>
</div>
